import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "TheFooterSocialLinks social-footer" }
const _hoisted_2 = { class: "social-footer__list" }
const _hoisted_3 = { class: "social-footer__list-item" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "social-footer__list-item" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "social-footer__list-item" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "social-footer__list-item" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "social-footer__list-item" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "social-footer__list-item" }
const _hoisted_14 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseImage = _resolveComponent("BaseImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("a", {
          href: _ctx.CONTACTS.twitter,
          rel: "noopener nofollow",
          target: "_blank",
          class: "social-footer__list-item-link link-with-opacity"
        }, [
          _createVNode(_component_BaseImage, {
            class: "social-footer__list-item-icon",
            src: require(`images/icons/white-twitter.svg`),
            alt: "twitter icon",
            "aria-label": "twitter icon"
          }, null, 8, ["src"]),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "social-footer__list-item-hidden" }, "Twitter", -1))
        ], 8, _hoisted_4)
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createElementVNode("a", {
          href: _ctx.CONTACTS.facebook,
          rel: "noopener nofollow",
          target: "_blank",
          class: "social-footer__list-item-link link-with-opacity"
        }, [
          _createVNode(_component_BaseImage, {
            class: "social-footer__list-item-icon is--facebook",
            src: require(`images/icons/white-facebook-f.svg`),
            alt: "facebook icon",
            "aria-label": "facebook icon"
          }, null, 8, ["src"]),
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "social-footer__list-item-hidden" }, "Facebook", -1))
        ], 8, _hoisted_6)
      ]),
      _createElementVNode("li", _hoisted_7, [
        _createElementVNode("a", {
          href: _ctx.CONTACTS.instagram,
          rel: "noopener nofollow",
          target: "_blank",
          class: "social-footer__list-item-link link-with-opacity"
        }, [
          _createVNode(_component_BaseImage, {
            class: "social-footer__list-item-icon",
            src: require(`images/icons/white-instagram.svg`),
            alt: "instagram icon",
            "aria-label": "instagram icon"
          }, null, 8, ["src"]),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "social-footer__list-item-hidden" }, "Instagram", -1))
        ], 8, _hoisted_8)
      ]),
      _createElementVNode("li", _hoisted_9, [
        _createElementVNode("a", {
          href: _ctx.CONTACTS.linkedin,
          rel: "noopener nofollow",
          target: "_blank",
          class: "social-footer__list-item-link link-with-opacity"
        }, [
          _createVNode(_component_BaseImage, {
            class: "social-footer__list-item-icon",
            src: require(`images/icons/white-linkedin-in.svg`),
            alt: "linkedin icon",
            "aria-label": "linkedin icon"
          }, null, 8, ["src"]),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "social-footer__list-item-hidden" }, "Linkedin", -1))
        ], 8, _hoisted_10)
      ]),
      _createElementVNode("li", _hoisted_11, [
        _createElementVNode("a", {
          href: _ctx.CONTACTS.youtube,
          rel: "noopener nofollow",
          target: "_blank",
          class: "social-footer__list-item-link link-with-opacity"
        }, [
          _createVNode(_component_BaseImage, {
            class: "social-footer__list-item-icon",
            src: require(`images/icons/white-youtube.svg`),
            alt: "youtube icon",
            "aria-label": "youtube icon"
          }, null, 8, ["src"]),
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "social-footer__list-item-hidden" }, "YouTube", -1))
        ], 8, _hoisted_12)
      ]),
      _createElementVNode("li", _hoisted_13, [
        _createElementVNode("a", {
          href: _ctx.RSS_LINK,
          rel: "noopener nofollow",
          target: "_blank",
          class: "social-footer__list-item-link link-with-opacity"
        }, [
          _createVNode(_component_BaseImage, {
            class: "social-footer__list-item-icon",
            src: require(`images/icons/white-rss.svg`),
            alt: "rss icon",
            "aria-label": "rss icon"
          }, null, 8, ["src"]),
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "social-footer__list-item-hidden" }, "RSS", -1))
        ], 8, _hoisted_14)
      ])
    ])
  ]))
}